import { t } from "i18next";
import PropTypes from "prop-types";
import { useSnapshot } from "valtio";

import React from "react";

import { kioskStore } from "@pages/Kiosk/store";

export function PreviousStep(
    props: React.SVGProps<SVGSVGElement>
): JSX.Element {
    const { customerLanguage } = useSnapshot(kioskStore);
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 224 65" {...props}>
            <g
                id="Groupe_53"
                data-name="Groupe 53"
                transform="translate(-5719 4106)"
            >
                <g
                    id="Rectangle_18"
                    data-name="Rectangle 18"
                    transform="translate(5719 -4106)"
                    fill="#fff"
                    stroke="#141414"
                    strokeWidth="2"
                >
                    <rect
                        width={props.width}
                        height={props.height}
                        rx="9"
                        stroke="none"
                    />
                    <rect
                        x="1"
                        y="1"
                        width={parseInt(props.width as string) - 2}
                        height={parseInt(props.height as string) - 2}
                        rx="8"
                        fill="#fff"
                    />
                </g>
                <text
                    id="Précédent"
                    transform="translate(5831 -4062)"
                    fill="#141414"
                    fontSize="29"
                    fontFamily="Roboto, sans-serif"
                    textAnchor="middle"
                >
                    {t("Previous", {
                        lng: customerLanguage.name,
                    })}
                </text>
            </g>
        </svg>
    );
}
PreviousStep.propTypes = {
    nameSvg: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    pointerEvents: PropTypes.string,
    opacity: PropTypes.string,
    onClick: PropTypes.func,
};
